import "./index.css";
import React from "react";

export default function UploadSectionHeader({
  shouldRenderButton,
  removeUploadPanel,
  value,
  onNameChange,
  id,
}) {
  return (
    <div className="upload-section-header">
      <input
        className="form-control form-control form-control-alt content-input upload-section-header__input"
        style={{ maxWidth: 320 }}
        type="text"
        name={`upload-section-${id}`}
        id={`upload-section-${id}`}
        placeholder="Section name"
        value={value}
        onChange={(e) => onNameChange(e, id)}
      />
      <label
        className="upload-section-header__label"
        htmlFor={`upload-section-${id}`}
      >
        Section name
      </label>
      {shouldRenderButton && (
        <button
          className="btn btn-white btn-sm upload-section-header__delete-btn"
          onClick={() => removeUploadPanel(id)}
        >
          Remove
        </button>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/ProductPortfolio/components/UploadSectionHeader/index.js